//TODO: Convert this to use Vue directives

export default {
  data() {
    return {
      selectedType: null,
      selectedOption: null,
    }
  },

  methods: {
    selectType: function ($ele) {
      $ele.removeClass('isInactive').addClass('active').data('toggle', '');
      $ele.siblings().removeClass('active').addClass('isInactive').data('toggle', '');

      // Hide the active tooltip
      $('#' + $ele.data('tooltip-id')).hide();

      this.selectedType = $ele.attr('data-type') || null;
      this.selectedOption = $ele.attr('data-option') || null;

      if(this.selectedType == 'assignment') {
        $('#js-cw-page-title').text('Create Assignment');
        $('#js-cw-assignment-types').show();
        $('#js-cw-assignment-types').find('a.btn-coursework').removeClass('active').removeClass('isInactive');
      } else if (this.selectedType == 'survey') {
        $('#js-cw-page-title').text('Create Survey');
        $('#js-cw-assignment-types').hide();
        $('#js-cw-survey-options').show();
        $('#js-cw-survey-options').find('a.btn-coursework').removeClass('active').removeClass('isInactive');
      } else if (this.selectedType == 'copy_coursework') {
        this.copyCoursework();
      } else {
        this.loadForm();
      }
    },

    resetType: function() {
      $('#js-cw-page-title').text('Create Coursework');
      $('a.btn-coursework').removeClass('active').addClass('isInactive').data('toggle', '');
      $('#js-cw-assignment-types').show();
      $('#js-cw-survey-options').hide();
    },

    unselectType: function ($ele) {
      $ele.removeClass('active').data('toggle', 'help-tooltip');
      $('#' + $ele.data('tooltip-id')).show(); //this works because visibility:none, etc. is embedded in the document.

      $('a.btn-coursework').removeClass('isInactive').data('toggle', 'help-tooltip');

      this.selectedType = $ele.attr('data-type') || null;
      if(this.selectedType == 'assignment') {
        $('#js-cw-assignment-types').addClass('hidden');
      } else if (this.selectedType == 'survey') {
        $('#js-cw-survey-options').addClass('hidden');
        $ele.siblings().each(function() {
          const $a = $(this);
          $a.removeClass('isInactive').data('toggle', 'help-tooltip');
          $('#' + $a.data('tooltip-id')).show(); //this works because visibility:none, etc. is embedded in the document.
        });
      }
      this.selectedType = null;
      this.selectedOption = null;
    },

    loadForm: function() {
      const courseId = Kadenze.Util.getCourseIdFromPath();
      const paramObj = _.omit({type: this.selectedType, option: this.selectedOption}, _.isEmpty);
      const params = $.param(paramObj);
      const url = Kadenze.Routes.new_course_coursework_path(courseId) + '?' + params;
      Kadenze.Request.pjax({url: url, container: '#main-pjax-container'});
    },

    copyCoursework: function() {
      const courseId = Kadenze.Util.getCourseIdFromPath();
      const url = Kadenze.Routes.new_cloner_coursework_path({slug: courseId});

      Kadenze.Request.pjax({url: url, container: '#main-pjax-container'});
    }
  },

  computed: {
    showPolicyModal() {
      return this.$el.dataset.showPolicyModal === 'true';
    },
  },

  mounted() {
    if (this.showPolicyModal) {
      Kadenze.UIUtil.confirmAction(
        I18n.t('coursework.new.no_grading_policies'),
        () => {
          window.location = Kadenze.Routes.course_grading_policy_entries_path(
            Kadenze.Util.getCourseIdFromPath()
          )
        },
        null,
        { title: 'Heads up!' }
      )
    }

    this.selectedType = null;
    this.selectedOption = null;

    $('.js-cw-assignment-type').on('click.courseworkType touchstart', e => {
      const $ele = $(e.currentTarget);

      this.selectType($ele);

      if($ele.attr('id') !== 'cww-copy-assignment')
        this.loadForm();
    });

    $('.js-cw-survey-option').on('click.courseworkOption touchstart', e => {
      const $ele = $(e.currentTarget);

      if ($ele.hasClass('active')) {
        this.unselectType($ele);
      } else {
        if ($ele.hasClass('disabled')) {
          new Kadenze.Notice.error({
            title: 'Templates not found',
            message: 'There are no templates to choose from at the moment. Please ask your admin to add survey templates.'
          });
        } else {
          this.selectType($ele);
          this.loadForm();
        }
      }
    });

    $('#js-cw-type-reset').on('click.courseworkTypeReset', () => this.resetType());

    this.resetType();

    const params = Kadenze.Util.getURLParams(window.location.search);

    if (params.redirect_type == 'survey')
      this.selectType($('.js-cw-survey-option'));
  }
};

